<template>
<div>

<v-dialog persistent width="600" v-model="msg.modals.filter">
<v-card>
  <v-toolbar flat>
    <v-toolbar-title>
    Фильтрация отображения результата
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <v-icon @click="msg.modals.filter= false">mdi-close</v-icon>
  </v-toolbar>
  <v-card-text>

<v-select
label="Выберите тип источника"
:items="sourceTypes"
>

</v-select>


<v-select
label="Выберите отправителя"
:items="sourceTypes"
>

</v-select>






<v-select
label="Выберите задание"
:items="sourceTypes"
>

</v-select>





  </v-card-text>
  <v-card-actions>
<v-spacer></v-spacer>

<v-btn small flat>Закрыть</v-btn>
<v-btn small flat>Применить</v-btn>
  </v-card-actions>
</v-card>

</v-dialog>



</div>
</template>




<script>
import axios from 'axios'
import chat from './chat.vue'
export default {
props: ['msg'],
components:{},
 data: function(){
  return {
sourceTypes:[
  'Любой источник',
  'Сообщества',
  'Страницы',
  'Процессы'
],

senders: [],


}
},

methods:{





},

computed:{

},

created (){

},


}
</script>
